var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEducationActive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 513366"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.75084 8.81524L6.50084 10.638L3.25084 8.81524V6.88938L2.32227 6.375V9.3567L6.50084 11.7003L10.6794 9.3567V6.375L9.75084 6.88938V8.81524Z",
    fill: "#0A7F8F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M6.5 0L0 3.36055V4.16299L6.5 7.76349L12.0714 4.67737V7.23401H13V3.36055L6.5 0ZM11.1429 4.13258L10.2143 4.64693L6.5 6.70453L2.78571 4.64693L1.85714 4.13258L1.21356 3.77607L6.5 1.04293L11.7864 3.77607L11.1429 4.13258Z",
    fill: "#0A7F8F"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEducationActive);
export default __webpack_public_path__ + "static/media/education_active.9ac6079a1b6e6a1bf460118344569c0c.svg";
export { ForwardRef as ReactComponent };